import { Major } from '@common-types';
import { baseService } from '@services/base.service';

export async function getStudyAreas(): Promise<Major[]> {
  return baseService.getAsync<Major[]>('/study-areas');
}
